import { useState } from 'react'
import { IconInfoCircle, IconX } from '@tabler/icons-react'

const DISMISS_KEY = 'heyalbum:selectionHintDismissed'

/**
 * Small dismissible hint shown while a selection is active on prof drives,
 * explaining the ways to select files. Dismissal is remembered locally.
 */
export default function SelectionHint({ visible }: { visible: boolean }) {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) === '1'
    } catch {
      return false
    }
  })

  if (!visible || dismissed) {
    return null
  }

  function dismiss() {
    setDismissed(true)
    try {
      localStorage.setItem(DISMISS_KEY, '1')
    } catch {
      // ignore
    }
  }

  return (
    <div className='fixed top-20 left-1/2 -translate-x-1/2 z-40 max-w-[92vw] px-2'>
      <div className='flex items-center gap-2 bg-neutral border border-base-300 shadow-lg rounded-full px-4 py-2 text-sm text-base-content'>
        <IconInfoCircle size={18} className='text-primary shrink-0' />
        <span>Bilder per Doppelklick oder Herz auswählen – oder ein ganzes Album über den Button.</span>
        <button type='button' className='ml-1 opacity-60 hover:opacity-100 shrink-0' onClick={dismiss} title='Ausblenden'>
          <IconX size={16} />
        </button>
      </div>
    </div>
  )
}
